import React from "react";

import { LOGO_BODY, LOGO_NODES, LOGO_VIEWBOX } from "./logo-paths";

// Definable logo mark. fill="currentColor" so it inherits the text color and
// adapts to light/dark theme automatically — set color via className.
export default function Logo({ size = 20, className = "" }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox={LOGO_VIEWBOX}
      width={size}
      height={Math.round(size * (547 / 562))}
      fill="none"
      className={`logo-mark ${className}`}
      aria-label="Definable"
    >
      <path fill="currentColor" d={LOGO_BODY[0]} />
      {LOGO_NODES.map((d, i) => (
        <path key={i} className="logo-node" style={{ animationDelay: `${i * 0.6}s` }} fill="currentColor" d={d} />
      ))}
      <path fill="currentColor" d={LOGO_BODY[1]} />
    </svg>
  );
}
